import { defineStore } from 'pinia';
import type { PlaceStatReduced, ReducedPlace } from '~/interfaces/publisher';

export const usePlaceModuleStore = defineStore('placeModuleStore', () => {
  const place = ref<ReducedPlace | null>(null);
  const stats = ref<PlaceStatReduced | null>(null);
  const colorOptions = ref([
    "#3B82F6", // blue
    "#EF4444", // red
    "#06B6D4", // cyan
    "#8B5CF6", // purple
    "#1F2937", // gray-dark
    "#2563EB", // blue-600
    "#F59E0B", // amber
    "#EC4899", // pink
    "#10B981", // green
  ]);

  return {
    place,
    stats,
    colorOptions,
  };
});
